import { Divider, VStack } from "@gluestack-ui/themed";
import { ReviewProposalController } from "./controller";
import { ProposalAccordion } from "@repo/core/components/layout/ProposalAccordion";
import { ProposalProductSection } from "@repo/core/components/layout/ProposalProductSection";
import { ProposalLocationSection } from "@repo/core/components/layout/ProposalLocationSection";
import { AlertModal } from "@repo/core/components/layout/ModalTemplate/AlertModal";
import { PageScaffold } from "@repo/core/components/layout/Scaffolds/PageScaffold";
import { ScaffoldFooter } from "@repo/core/components/layout/Scaffolds/components/ScaffoldFooter";
import { GenderEnum } from "@repo/core/enums/proposals";

const ReviewProposal = () => {
  const {
    handleGoBack,
    handleSubmit,
    handleEditAddressData,
    handleEditPersonalData,
    isAccordionsStartOpened,
    handleEditProfessionData,
    handleEditSelectServicePoint,
    handleEditSelectProduct,
    handleClose,
    handleAbandon,
    securityData,
    personalData,
    addressData,
    professionData,
    selectedProduct,
    selectedServicePoint,
    isOnlyView,
    isSaving,
    isWaitingCreditAnalysis,
    alertModalRef,
    getAlertModalProps
  } = ReviewProposalController();
  const isSubmissionPending = isSaving || isWaitingCreditAnalysis;

  return (
    <>
      <PageScaffold
        bg="$backgroundLight0"
        title={isOnlyView ? "Dados da proposta" : "Revisar Proposta"}
        onBackPress={handleGoBack}
        showBackButtonOnWeb
        onPressRightIcon={handleClose}
        rightWebLabel="Fechar"
        footerContent={
          <ScaffoldFooter
            primaryText="Enviar para análise"
            primaryAction="primary"
            primaryOnPress={handleSubmit}
            primaryIsLoading={isSubmissionPending}
            primaryIsDisabled={isSubmissionPending}
            secondaryText="Abandonar"
            secondaryAction="darker-secondary"
            secondaryVariant="outline"
            secondaryOnPress={handleAbandon}
            secondaryIsDisabled={isSubmissionPending}
          />
        }
      >
        <VStack w="$full" gap="$6" pb="$4" bg="$backgroundLight0">
          <VStack my="$3" />
          <ProposalAccordion.Security
            title="Dados de Segurança"
            value="securityData"
            isOpen={isAccordionsStartOpened}
            cpf={securityData.cpf}
            name={securityData.fullName}
            phone={securityData.cellPhone}
          />
          <Divider />
          <ProposalAccordion.Personal
            title="Dados Pessoais"
            value="personalData"
            isOpen={isAccordionsStartOpened}
            {...personalData}
            gender={personalData.gender as GenderEnum | null}
            onPressEdit={
              isSubmissionPending ? undefined : handleEditPersonalData
            }
          />
          <Divider />
          <ProposalAccordion.Address
            title="Endereço Residencial"
            value="addressData"
            isOpen={isAccordionsStartOpened}
            {...addressData}
            onPressEdit={
              isSubmissionPending ? undefined : handleEditAddressData
            }
          />
          <Divider />
          <ProposalAccordion.Professional
            title="Atividade Profissional"
            value="professionalData"
            isOpen={isAccordionsStartOpened}
            {...professionData}
            profession={
              professionData.professionName || professionData.profession
            }
            professionalCategory={
              professionData.professionalClassDescription ||
              professionData.professionalCategory
            }
            onPressEdit={
              isSubmissionPending ? undefined : handleEditProfessionData
            }
          />
          <Divider />
          <ProposalProductSection
            name={selectedProduct?.name || ""}
            description=""
            cardNumber={selectedProduct?.number || ""}
            onPressChangeProduct={
              isSubmissionPending ? undefined : handleEditSelectProduct
            }
          />
          <Divider />
          {/*  <ProposalFinancialServicesSection
            name={selectedFinancialService?.title || ""}
            value={selectedFinancialService?.subtitle || ""}
            onPressChangeFinancialServices={handleEditFinancialServices}
          />
          <Divider /> */}
          <ProposalLocationSection
            name={selectedServicePoint?.descricao || ""}
            region={selectedServicePoint?.ponto || ""}
            onPressChangeLocation={
              isSubmissionPending ? undefined : handleEditSelectServicePoint
            }
          />
        </VStack>
      </PageScaffold>
      <AlertModal ref={alertModalRef} {...getAlertModalProps()} />
    </>
  );
};

export default ReviewProposal;
